document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");

  const hotspots = document.querySelectorAll('.hotspot-section');
  const hotspots_closebtns = document.querySelectorAll('[js-hotspot-content-mobile--closebtn]');
  const hotspots_bg = document.querySelectorAll('[js-hotspot-content-mobile--bg]');

  function hideElementWhenOtherPositioned() {
    document.addEventListener('click', (e) => {
      const element = e.target;
      if (!element.classList.contains('hotspot-content') && !element.classList.contains('hotspot') && !element.classList.contains('hotspot-link')) {
        hotspots.forEach(hotspot => {
          const contents = hotspot.querySelectorAll('[js-hotspot-content]');

          contents.forEach(content => {
            content.classList.remove('active')
          });
        });
      }
    });

    hotspots.forEach(element => {
      const spots = element.querySelectorAll('[js-hotspot-dot]');
      const contents = element.querySelectorAll('[js-hotspot-content]');
      const mobile_contents = element.querySelectorAll('[js-hotspot-content-mobile]');
  
      spots.forEach(spot => {
        spot.addEventListener('click', (e) => {
          e.preventDefault();
          
          const blockId = spot.getAttribute('data-block-id');
          contents.forEach(content => {
            const contentId = content.getAttribute('data-block-id');
  
            if (blockId == contentId) {
              if (content.classList.contains('active')) {
                content.classList.remove('active');
              } else {
                content.classList.add('active');
              }
            } else {
              content.classList.remove('active');
            }
          });

          mobile_contents.forEach(content => {
            const contentId = content.getAttribute('data-block-id');
  
            if (blockId == contentId) {
              if (content.classList.contains('active')) {
                content.classList.remove('active');
              } else {
                content.classList.add('active');
              }
            } else {
              content.classList.remove('active');
            }
          });
        });
      });
    });

    hotspots_closebtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const mobile_contents = document.querySelectorAll('[js-hotspot-content-mobile]');
        mobile_contents.forEach(content => {
          content.classList.remove('active');
        });
      });
    });

    hotspots_bg.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const mobile_contents = document.querySelectorAll('[js-hotspot-content-mobile]');
        mobile_contents.forEach(content => {
          content.classList.remove('active');
        });
      });
    });
  }

  hideElementWhenOtherPositioned();

  const accordionTabs = document.querySelectorAll('.wt-page__wrapper p button.accordion');
  const panels = document.querySelectorAll('.wt-page__wrapper div.panel');
  accordionTabs.forEach(accordion => {
    accordion.addEventListener('click', (e) => {
      e.preventDefault();
      panels.forEach(panel => {
        panel.classList.remove('active');
      });

      const activePanel = accordion.parentNode.nextElementSibling;
      activePanel.classList.add('active');
    })
  });
});